import React from 'react'
import Reveal from './Reveal'

interface Props {
    eyebrow: string
    title?: string
    description?: string
    align?: 'left' | 'center'
    inverted?: boolean
    action?: React.ReactNode
}

function SectionHeader({ eyebrow, title, description, align = 'left', inverted, action }: Props) {
    return (
        <Reveal className={`ibg-section-header ibg-section-header--${align} ${inverted ? 'is-inverted' : ''}`}>
            <div className="ibg-section-header__text">
                <span className="ibg-eyebrow">{eyebrow}</span>
                {title && <h2 className="ibg-h2">{title}</h2>}
                {description && <p className="ibg-lead">{description}</p>}
            </div>
            {action && <div className="ibg-section-header__action">{action}</div>}
        </Reveal>
    )
}

export default SectionHeader
